<template>
  <div style="height: 100%;width: 100%">
    <lf-layout
        menuShow
        ref="layoutRef"
        class="t-lf-layout"
        :styleBlue="false"
        :logoUrl="logoUrl"
        :title="title"
        :menuList="menuList"
        :activeIndex="activeIndex"
        :activeIndexCanChange="true"
        navShow
        :breadList="breadList"
        :auth="false"
        :help="false"
        :itReport="false"
        :moreFunction="moreFunction"
        :customFunction="customFunction"
        :userInfor="userInfor"
        :userMore="userMore"
        @logoHandle="logoHandle"
        @menuCallBack="menuCallBack"
        @handleOpen="handleOpen"
        @handleClose="handleClose"
        @icon-switch="iconSwitch"
        @breadCallBack="breadCallBack"
        @authCallBack="authCallBack"
        @helpCallBack="helpCallBack"
        @itReportCallBack="itReportCallBack"
        @customFunctionCallBack="customFunctionCallBack"
        @moreActiveCallBack="moreActiveCallBack"
        @userMoreCallBack="userMoreCallBack"
    >
      <slot></slot>
      <!-- 返回上一级按钮 -->
<!--      <template #headerLeft>-->
<!--        <slot name="headerLeft">-->
<!--          <span v-if="showBack">-->
<!--            <el-button class="back-btn" link :icon="ArrowLeft" @click="goBack">返回列表页</el-button>-->
<!--          </span>-->
<!--        </slot>-->
<!--      </template>-->
    </lf-layout>
    <notice-board
        ref="noticeboard"
    />
  </div>
</template>
<script setup lang="ts">
  import {
    watch, computed, ref
  } from 'vue';
  import { ArrowLeft } from '@element-plus/icons-vue';

  import logoUrl from "@/assets/images/logo-bi.png";
  import { useRoute, useRouter } from "vue-router";
  import {usePermissionStore} from "@/store/modules/permission";
  import {useStore} from "vuex";
  import {useUserStore} from "@/store/modules/user";
  import NoticeBoard from "@/layout/components/NoticeBoard/index.vue";
  import {SET_COLLAPSE_STATUS} from "@/store/actionTypes";
  import iconFastChat from "@/icons/person-chat.svg";
  import iconItsm from "@/icons/itsm.svg";
  import iconFastIT from "@/icons/IT.svg";
  import iconNotice from "@/icons/icon-notice-nanbar.svg";
  import iconUsername from "@/icons/username.svg";
  const route = useRoute();
  const router = useRouter();
  const store = useStore();
  const showBack = ref(false)

  const permissionStore = usePermissionStore();
  const userStore = useUserStore();

  const title = '一站式分析平台'
  const layoutRef = ref()
  const personOnDuty = computed(() => store.state.app.personOnDuty);
  const isCollapseAct = computed(() => store.state.app.collapseAct);
  console.log('isCollapseAct---',isCollapseAct)
  const userInfo = computed(() => userStore.userInfo);
  const noticeboard = ref()
  const menuList = computed(() => mapMenuList(permissionStore.permissionRoutes));
  const userInfor = computed(() => {
    return {
      // avatar: iconUsername,
      avatar: userInfo.value.headPortrait || iconUsername,
      userName: userInfo.value && userInfo.value.username,
    }
  });
  const activeIndex = ref('') as any;
  const breadList:any=ref([])
  const customFunction: any[]=[
    // {
    //   title: '快速咨询',
    //   icon: iconFastChat,
    //   id: 'fastChat',
    // },
    {
      title: '用户手册',
      icon: iconItsm,
      id: 'userHelp',
    },
    {
      title: 'IT报事',
      id: 'it',
      icon: iconFastIT,
    },
  ]

  const moreFunction: any[]=[
    // {
    //   title: 'IT报事',
    //   key: 'it',
    //   id: 'it',
    //   icon: iconFastIT,
    // },
    {
      title: '公告栏',
      key: 'notice',
      id: 'notice',
      icon: iconNotice,
    },
  ]
  const userMore: any[]= [
    // {
    //   id: 1,
    //   title: '修改密码'
    // }
  ]

  watch(
    route,
    (val) => {
      console.log(val);
      activeIndex.value = val?.meta?.activeMenu || val.path;
      getBreadList()
      if (val.name === "demand-detail-index") {
        showBack.value = true
      } else {
        showBack.value = false
      }
    },
    {
      immediate: false,
    },
  );
  watch(
      isCollapseAct,
    (val) => {
      console.log('---isCollapseAct---',val,layoutRef.value)
        if (layoutRef.value) {
          console.log('----2-----')
          layoutRef.value.closeMenu()
        }
        // else if (val && layoutRef.value){
        //   layoutRef.value.openMenu()
        // }
    },
    {
      immediate: true,
    },
  );
  const goBack = () => {
    // router.back();
    router.push({
      name: 'demand-center-index',
      query: { type: 'back' }
    })
  };
  function getBreadList() {
    const matched: any = route?.matched.filter((item) => item.meta && item.meta.title) || [];
    for (let i = 0; i < matched.length; i++) {
      matched[i].title = matched[i].meta.title
    }
    breadList.value = matched
  }
  function mapMenuList(routes: any){
    // console.log('mapMenuList----',routes)
    let arr: { children?: any[]; name: any; icon: any; id: any; }[] = []
    routes.forEach((item: any) => {
      if (!item.meta.hidden) {
        let value = {
          name: item.meta.title || '--',
          icon: activeIndex.value === item.meta.activeMenu ? item.meta.activeIcon : item.meta.icon,
          id: item.path,
        }
        if (item.children && item.children.length) {
          arr.push({
            ...value,
            children: mapMenuList(item.children),
          })
        } else {
          arr.push(value)
        }
      }
    });
    return arr
  }

  const logoHandle = (type: any) => {
    console.log('点击了logo或产品名称', type);
  }
  const menuCallBack = (menu: any) => {
    console.log('点击了末级菜单', menu);
    router.push(menu.id)
  }
  const handleOpen = (key: any, keyPath: string) => {
    console.log('--open', key, keyPath)
    // router.push(key)
  }
  const handleClose = (key: any, keyPath: string) => {
    console.log('--handleClose', key, keyPath)
  }
  const iconSwitch = (status: any) => {
    console.log('--iconSwitch', status)
    store.commit(`app/${SET_COLLAPSE_STATUS}`, status);
  }
  const breadCallBack = (item: any) => {
    console.log('--breadCallBack', item)
    if (item.name === "demand-center") {
      router.push({
        name: 'demand-center-index',
        query: { type: 'back' }
      })
    } else {
      router.push(item.path)
    }
  }
  const authCallBack=() => {
    console.log('--authCallBack')
  }
  const helpCallBack=() => {
    console.log('--helpCallBack')
  }
  const itReportCallBack=() => {
    console.log('--itReportCallBack')
  }
  const customFunctionCallBack = (item: any) => {
    console.log('--customFunctionCallBack', item)
    switch (item.id) {
      case 'fastChat':
        handleOpenChat();
        break
      case 'userHelp':
        handleOpenUserHelp();
        break
      case 'it':
        handleOpenIT();
        break
    }
  }
  // 点击更多
  const moreActiveCallBack = (item: any) => {
    console.log('--moreActiveCallBack', item)
    switch (item.id) {
      case 'it':
        handleOpenIT();
        break
      case 'notice':
        openNotice();
        break
    }
  }
  const userMoreCallBack = (item: any) => {
    console.log('--userMoreCallBack', item)
    switch (item.id) {
      case '9999':
        logoutHandle();
        break
    }
  }
  // 点击快速咨询
  const handleOpenChat = () => {
    if (personOnDuty.value){
      window.zhuge.track('快速咨询', {
        所在页面: route.meta.title,
      });
      const protocal = window.location.host === 'idata.longfor.com' ? 'longfor' : 'longforuat';
      window.location.href = `${protocal}://im/startChat?conversationType=1&account=${userInfo.value.oa}&userAccount=${personOnDuty.value}`;
    }
  }
  // 点击用户手册
  const handleOpenUserHelp = () => {
    window.open('https://idoc.longfor.com/word/wf1DZ3iwdsdgYVqYTCblA79WxmOn','_blank')
  }
  // 点击IT报事
  const handleOpenIT = () => {
    const url = 'https://itsm.longfor.com/quick-web/?sysId=244953&sourcesysId=227016&appKey=c0b99d3bf3a541518e83d039478c95e4&flowCode=TYFXJCPT#/'
    window.zhuge.track('IT报事', {
      所在页面: route.meta.title,
    });
    window.open(url,'_blank')
  }
  // 打开公告栏
  const openNotice = () => {
    console.log('openNotice----')
    window.zhuge.track('公告栏', {
      所在页面: route.meta.title,
    });
    noticeboard.value.viewallbulletin();
  }
  // 退出登录
  const logoutHandle = () => {
    userStore.logout();
  };

</script>
<style scoped lang="scss">
.t-lf-layout {
  width: 100%;
  .back-btn{
    height: 14px;
    line-height: 14px;
    color: #007af5;
    //&:hover{
    //  color: #007af5;
    //}
  }
  :deep(.lf-layout-content) {
    background-color: #fff;
    margin-bottom: 10px;
    width: 100%;
  }

  :deep(.menu-simple){
    .txt-ellipsis{
      font-size: 11px;
    }
  }
  :deep(.layout-menu){
    .menu-logo{
      .logo-icon{
        width: 19px;
        height: 19px;
        left: 19px;
      }
    }
  }
  :deep(.layout-menu:not(.menu-simple)){
    .menu-logo{
      .logo-name{
        width:100px
      }
    }
  }
  :deep(.right-options){
    >ul{
      //li:first-of-type{
      //  &:hover{
      //    .option-title{
      //      color: #007af5;
      //    }
      //  }
      //  .option-title{
      //    color: #007af5;
      //  }
      //}
    }
  }
}
</style>
